import moment from 'moment'
import React, { useState } from 'react'
import { MoreVertical, UserX } from 'react-feather'
import { Link } from 'react-router-dom'
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'
import PullAffiliateModal from '../../../../components/PullAffiliateModal/PullAffiliateModal'
import { useAuth, useProtectedContent } from '../../../../context/AuthContext'
import useDateRangeFilter from '../../../../hooks/useDateRangeFilter'

export default function ReportsStatsDropdown({ affiliateId, campaignId, advertiserId, creativeId, landingPageId, subid1, date, startDate, endDate, withAvatar, navigation, showSystemMessage, openModal }) {
    const auth = useAuth()
    const showPullAff = useProtectedContent(auth.permissions, 'campaign_pull_aff')

    let [dropdownOpen, setDropdownOpen] = useState(false)
    let [pullAffiliateModal, setPullAffiliateModal] = useState({
        // open: false,
        affiliate: {
            id: 0,
            name: '',
        },
        campaign: {
            id: 0,
            name: '',
        },
    })
    const { initStartDate, initEndDate } = useDateRangeFilter()

    const buildUrlDateOnly = (url, customStartDate, customEndDate) => {
        if (date) {
            url = url + `?startDate=${date}&endDate=${date}`
        } else if (customStartDate || customEndDate) {
            let finalStartDate = customStartDate ? customStartDate : initStartDate
            let finalEndDate = customEndDate ? customEndDate : initEndDate
            url = url + `?startDate=${finalStartDate}&endDate=${finalEndDate}`
        } else {
            let finalStartDate = startDate ? startDate : initStartDate
            let finalEndDate = endDate ? endDate : initEndDate
            url = url + `?startDate=${finalStartDate}&endDate=${finalEndDate}`
        }

        return url
    }

    const buildUrl = (url, showWithAvatar, customStartDate, customEndDate) => {
        if (date) {
            url = url + `?startDate=${date}&endDate=${date}`
        } else if (customStartDate || customEndDate) {
            let finalStartDate = customStartDate ? customStartDate : initStartDate
            let finalEndDate = customEndDate ? customEndDate : initEndDate
            url = url + `?startDate=${finalStartDate}&endDate=${finalEndDate}`
        } else {
            let finalStartDate = startDate ? startDate : initStartDate
            let finalEndDate = endDate ? endDate : initEndDate
            url = url + `?startDate=${finalStartDate}&endDate=${finalEndDate}`
        }

        if (subid1) {
            url = url + `&subid1=${subid1}`
        }

        if (affiliateId > 0) {
            url = url + `&affiliateId=${affiliateId}`
        }

        if (campaignId > 0) {
            url = url + `&campaignId=${campaignId}`
        }

        if (advertiserId > 0) {
            url = url + `&advertiserId=${advertiserId}`
        }

        if (creativeId > 0) {
            url = url + `&creativeId=${creativeId}`
        }

        if (landingPageId > 0) {
            url = url + `&landingPageId=${landingPageId}`
        }

        if (showWithAvatar && withAvatar === 'true') {
            url = url + `&withAvatar=true`
        }

        if (navigation) {
            url = url + `&navigation=${navigation}`
        }

        return url
    }

    const handleClose = () => {
        setPullAffiliateModal({
            open: false,
            affiliate: {
                id: 0,
                name: '',
            },
            campaign: {
                id: 0,
                name: '',
            },
        })
    }

    return (
        <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)} direction="left">
            <DropdownToggle tag="a" onClick={() => setDropdownOpen(!dropdownOpen)} data-toggle="dropdown" aria-expanded={dropdownOpen} className="report-more-toggle">
                <MoreVertical size={20} />
            </DropdownToggle>
            {showPullAff && (pullAffiliateModal.open && <PullAffiliateModal data={pullAffiliateModal} showSystemMessage={showSystemMessage} isOpen={pullAffiliateModal.open} handleClose={handleClose} advertiserId={advertiserId} />)}
            <DropdownMenu>
                {campaignId > 0 && !creativeId && !landingPageId && (
                    <>
                        <Link className="dropdown-item" to={buildUrl(`/reports/stats/creatives`, true)} onClick={() => setDropdownOpen(!dropdownOpen)}>
                            By Creative
                        </Link>
                    </>
                )}

                {campaignId > 0 && !creativeId && !landingPageId && (
                    <>
                        <DropdownItem divider className="m-0" />{' '}
                        <Link className="dropdown-item" to={buildUrl(`/reports/stats/landingPages`, true)} onClick={() => setDropdownOpen(!dropdownOpen)}>
                            By Landing Page
                        </Link>
                    </>
                )}

                {/* There is a campaign AND an affiliate */}
                {(campaignId > 0 || affiliateId > 0) && !creativeId && !landingPageId && (
                    <>
                        <DropdownItem divider className="m-0" />{' '}
                        <Link className="dropdown-item" to={buildUrl(`/reports/stats/subid`, true)} onClick={() => setDropdownOpen(!dropdownOpen)}>
                            By Subid1
                        </Link>
                    </>
                )}

                {/* There is a campaign or advertiser, and no affiliate */}
                {(campaignId > 0 || advertiserId > 0) && (!affiliateId || affiliateId === 0) && (
                    <>
                        <DropdownItem divider className="m-0" />{' '}
                        <Link className="dropdown-item" to={buildUrl(`/reports/stats/affiliates`)} onClick={() => setDropdownOpen(!dropdownOpen)}>
                            By Affiliate
                        </Link>
                    </>
                )}

                {((affiliateId > 0 && (!campaignId || campaignId === 0)) || (advertiserId > 0 && (!campaignId || campaignId === 0))) && (
                    <>
                        <DropdownItem divider className="m-0" />{' '}
                        <Link className="dropdown-item" to={buildUrl(`/reports/stats/campaigns`, true)} onClick={() => setDropdownOpen(!dropdownOpen)}>
                            By Campaign
                        </Link>
                    </>
                )}

                {!date && (campaignId > 0 || affiliateId > 0 || advertiserId > 0) && (
                    <>
                        <DropdownItem divider className="m-0" />{' '}
                        <Link className="dropdown-item" to={buildUrl(`/reports/stats/daily`, true)} onClick={() => setDropdownOpen(!dropdownOpen)}>
                            By Day
                        </Link>
                    </>
                )}

                {!date && (campaignId > 0 || affiliateId > 0 || advertiserId > 0) && (
                    <>
                        <DropdownItem divider className="m-0" />{' '}
                        <Link className="dropdown-item" to={buildUrl(`/reports/stats/monthly`, true)} onClick={() => setDropdownOpen(!dropdownOpen)}>
                            By Month
                        </Link>
                    </>
                )}

                {!date && (campaignId > 0 || affiliateId > 0 || advertiserId > 0) && (
                    <>
                        <DropdownItem divider className="m-0" />{' '}
                        <Link className="dropdown-item" to={buildUrl(`/reports/stats/monthly`, true, moment().startOf('year').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'))} onClick={() => setDropdownOpen(!dropdownOpen)}>
                            By Month for Year
                        </Link>
                    </>
                )}

                {
                    (affiliateId > 0 && campaignId > 0 && (navigation === 'affiliate' || navigation === 'campaign')) && (
                        <>
                            <DropdownItem divider className="m-0" />{' '}
                            <Link className="dropdown-item" to={`${buildUrlDateOnly(`/affiliate/${affiliateId}/clickReferrers`)}&campaignId=${campaignId}`} onClick={() => setDropdownOpen(!dropdownOpen)}>
                                Click Referrers
                            </Link>
                            <DropdownItem divider className="m-0" />{' '}
                            <Link className="dropdown-item" to={`${buildUrlDateOnly(`/affiliate/${affiliateId}/leadReferrers`)}&campaignId=${campaignId}`} onClick={() => setDropdownOpen(!dropdownOpen)}>
                                Lead Referrers
                            </Link>
                        </>
                    )
                }

                {
                    (affiliateId > 0 && campaignId > 0 && (navigation === 'affiliate' || navigation === 'campaign')) && (
                        <>
                            <DropdownItem divider className="m-0" />{' '}
                            <Link className="dropdown-item" to={navigation === 'affiliate' ? `${buildUrlDateOnly(`/affiliate/${affiliateId}/analytics`)}&campaignId=${campaignId}` : `${buildUrlDateOnly(`/campaign/${campaignId}/analytics`)}&affiliateId=${affiliateId}`} onClick={() => setDropdownOpen(!dropdownOpen)}>
                                Traffic Analytics
                            </Link>
                        </>
                    )
                }

                {
                    (campaignId > 0 && (!affiliateId || affiliateId === 0) && (!landingPageId || landingPageId === 0) && (!creativeId || creativeId === 0) && (!advertiserId || advertiserId === 0) && (!subid1 || subid1 === 0)) && (
                        <>
                            <DropdownItem divider className="m-0" />{' '}
                            <Link className="dropdown-item" to={`${buildUrlDateOnly(`/avatar/reports/affiliate`)}&offerId=${campaignId}`} onClick={() => setDropdownOpen(!dropdownOpen)}>
                                Avatar - Affiliates
                            </Link>
                        </>
                    )
                }

                {affiliateId > 0 && (campaignId > 0 || advertiserId > 0) && showPullAff && (
                    <>
                        <DropdownItem divider className="m-0" />{' '}
                        <button
                            className="btn btn-link dropdown-item text-danger"
                            onClick={() => {
                                setDropdownOpen(!dropdownOpen)
                                setPullAffiliateModal({ affiliate: { id: affiliateId, name: '' }, campaign: { id: campaignId, name: '' }, open: true })
                            }}
                        >
                            <UserX size={14} /> Pull Affiliate
                        </button>
                    </>
                )}
            </DropdownMenu>
        </Dropdown>
    )
}
